import type { UnitGroup, UnitRoster } from '../battle/units';
import type { BattleState } from '../battle/battleEngine';
import type { ScoutingConfig } from '../../config/gameConfig';

export type ScoutingStatus = 'traveling' | 'battle' | 'holding' | 'returning' | 'complete';

export type ScoutingMission = {
    id: string;
    fromSettlementId: string;
    targetTileId: string;
    currentTileId: string;
    route: string[];
    routeIndex: number;
    units: UnitGroup[];
    initialUnits: UnitGroup[];
    plan: string[];
    foodSupplies: number;
    weaponsIssued: number;
    distance: number;
    travelTicks: number;
    startDelay: number;
    stepTicks: number;
    resumeStatus?: 'traveling' | 'returning';
    progress: number;
    status: ScoutingStatus;
    createdAt: number;
    completedAt?: number;
    battle?: BattleState;
    battleReportId?: string;
};

export function suggestScoutingFood(
    units: UnitGroup[],
    roster: UnitRoster,
    distance: number,
    config: ScoutingConfig,
): number {
    const total = units.reduce((sum, group) => {
        const unit = roster.get(group.type);
        if (!unit) return sum;
        return sum + unit.foodPerHex * group.count;
    }, 0);
    const roundTrip = distance * 2;
    return Math.max(0, Math.ceil(total * roundTrip * config.foodMultiplier));
}

export function getScoutingTravelTicks(distance: number, config: ScoutingConfig): number {
    return Math.max(1, Math.round(config.baseTicks + distance * config.ticksPerHex));
}

export function startReturnMission(mission: ScoutingMission, config: ScoutingConfig): boolean {
    if (mission.status !== 'holding') return false;
    mission.status = 'returning';
    mission.progress = 0;
    mission.route = [];
    mission.routeIndex = 0;
    mission.startDelay = Math.max(0, Math.round(config.baseTicks));
    mission.stepTicks = Math.max(1, Math.round(config.ticksPerHex));
    mission.travelTicks = getScoutingTravelTicks(mission.distance, config);
    return true;
}
